<script>
/**
 * ****************************************************************************
 * @description     :   Input File Component
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import template
 */
import template from './template.html';

/**
 * Define content of input file component
 */
var FcFile = {
    template: template,
    props: {
        id: String,
        label: String,
        itemClass: String,
        labelClass: String,
        inputClass: String,
        placeholder: String,
        modelValue: Object,
        isRequired: Boolean,
        isDisabled: Boolean,
        isReadonly: Boolean,
        onChange: Function,
        onFocus: Function,
        onBlur: Function
    },
    emits: ['update:modelValue'],
    methods: {
        /**
         * event forcus on input file
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        focusInput(e) {
            if (this.onFocus) {
                this.onFocus(e);
            }
        },
        /**
         * event blur on input file
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        blurInput(e) {
            if (this.onBlur) {
                this.onBlur(e);
            }
        },
        /**
         * update input file
         * -----------------------------------------
         * @author : QuyPN - 2023/03/28 - create
         * @params :
         * @access : private
         */
        updateInput(e) {
            this.$emit('update:modelValue', e.target.files[0]);
            if (this.onChange) {
                this.onChange(e);
            }
        }
    }
};
export default FcFile;
</script>
